<form #thisForm="ngForm" [ngClass]="{ 'card mt-3': showHeader === true }">
  <div class="card-header text-uppercase" *ngIf="showHeader">
    Dados do Fundo
  </div>
  <div [ngClass]="{ 'card-body': showHeader === true }">
    <div class="row mb-2">
      <div class="col-4" [class.has-error]="hasError('document')">
        <label>CNPJ</label>
        <ng-select
          notFoundText="Fundo não encontrado"
          typeToSearchText="Digite o CNPJ do fundo para pesquisar..."
          [selectOnTab]="true"
          (change)="fillComponentWhenFundSelected()"
          [(ngModel)]="selectedFund"
          [ngModelOptions]="{ standalone: true }"
          [typeahead]="fundSearchDocumentTerm"
          [items]="fundsByDocument | async"
          [clearable]="false"
          bindLabel="document"
          [disabled]="!formEnabled || documentIsDisabled"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.document }}
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            {{ item.document }} {{ item.name }}
          </ng-template>
        </ng-select>
      </div>

      <div *ngIf="!isWallet" class="col-8" [class.has-error]="hasError('bank')">
        <label>Dados Bancários</label>
        <ng-select
          notFoundText="Banco, Agência ou Conta Corrente não encontradas"
          typeToSearchText="Digite Banco, Agência ou Conta Corrente"
          [selectOnTab]="true"
          (change)="fillComponentWhenFundAccountSelected()"
          [(ngModel)]="selectedFundAccount"
          [ngModelOptions]="{ standalone: true }"
          [items]="fundAccountList"
          [clearable]="false"
          [disabled]="!formEnabled || fundAccountIsDisabled"
        >
          <ng-template
            ng-label-tmp
            let-item="item"
            *ngIf="selectedFundAccount !== null"
          >
            Banco: {{ item.bank }}&nbsp;&nbsp;&nbsp;&nbsp;Agência:
            {{ item.branch }}&nbsp;&nbsp;&nbsp;&nbsp;Conta Corrente:
            {{ item.account }}
          </ng-template>
          <ng-template ng-header-tmp *ngIf="fundAccountList !== null">
            <div class="row mb-2">
              <div class="col-4">Banco</div>
              <div class="col-4">Agência</div>
              <div class="col-4">Conta</div>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="row mb-2">
              <div class="col-4">{{ item.bank }}</div>
              <div class="col-4">{{ item.branch }}</div>
              <div class="col-4">{{ item.account }}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="row mb-2">
      <div [ngClass]="viewStockButton() || isWallet ? 'col-10' : 'col-12'">
        <div [class.has-error]="hasError('name')">
          <label>Nome do Fundo</label>
          <ng-select
            notFoundText="Fundo não encontrado"
            typeToSearchText="Digite o nome do fundo para pesquisar..."
            [selectOnTab]="true"
            (change)="fillComponentWhenFundSelected()"
            [(ngModel)]="selectedFund"
            [ngModelOptions]="{ standalone: true }"
            [typeahead]="fundSearchNameTerm"
            [items]="fundsByName | async"
            [clearable]="false"
            bindLabel="name"
            [disabled]="!formEnabled || nameIsDisabled"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div [ngClass]="viewStockButton() || isWallet ? 'col-5 mt-2' : 'col-12'">
        <div [class.has-error]="hasError('startDate')">
          <label>Data Início</label>
          <input
            data-cy="startDate"
            type="date"
            class="form-control"
            name="startDate"
            required
            [readonly]="true"
          />
        </div>
      </div>
      <div [ngClass]="viewStockButton() || isWallet ? 'col-5 mt-2' : 'col-12'">
        <div [class.has-error]="hasError('endDate')">
          <label>Data Fim</label>
          <input
            data-cy="endDate"
            type="date"
            class="form-control"
            name="endDate"
            required
            [readonly]="true"
          />
        </div>
      </div>
      <div [ngClass]="viewStockButton() || isWallet ? 'col-10 mt-2' : 'col-12'">
        <div [class.has-error]="hasError('name')">
          <label>Tipo de Relatório (Ativo)</label>
          <ng-select
            notFoundText="Tipo não encontrado"
            [selectOnTab]="true"
            [items]="reportTypesFunds"
            bindLabel="name"
            [multiple]="true"
            [closeOnSelect]="false"
          >
            <ng-template
              ng-option-tmp
              let-item="item"
              let-item$="item$"
              let-index="index"
            >
              <input
                id="item-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected"
                name="roleSel-{{ index }}"
              />
              {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div
        [ngClass]="viewStockButton() || isWallet ? 'col-10 mt-2' : 'col-12'"
        *ngIf="!isWalletUpload"
      >
        <div [class.has-error]="hasError('name')">
          <label>Tipo de Relatório (Passivo)</label>
          <ng-select
            notFoundText="Tipo não encontrado"
            [selectOnTab]="true"
            [items]="reportTypesLiabilities"
            bindLabel="name"
            [multiple]="true"
            [closeOnSelect]="false"
            [(ngModel)]="selectedReportTypesLiabilities"
            name="selectedReportTypesLiabilities"
          >
            <ng-template
              ng-option-tmp
              let-item="item"
              let-item$="item$"
              let-index="index"
            >
              <input
                id="item-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected"
                name="roleSel-{{ index }}"
              />
              {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div
        [ngClass]="viewStockButton() || isWallet ? 'col-10 mt-2' : 'col-12'"
        *ngIf="selectedReportTypesLiabilities.length > 0"
      >
        <div [class.has-error]="hasError('name')">
          <label>Cotistas</label>
          <ng-select
            notFoundText="Tipo não encontrado"
            [selectOnTab]="true"
            [items]="reportCotistas"
            bindLabel="name"
            [multiple]="true"
            [closeOnSelect]="false"
          >
            <ng-template
              ng-option-tmp
              let-item="item"
              let-item$="item$"
              let-index="index"
            >
              <input
                id="item-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected"
                name="roleSel-{{ index }}"
              />
              {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div
        [ngClass]="viewStockButton() || isWallet ? 'col-10 mt-2' : 'col-12'"
        *ngIf="isWalletUpload"
      >
        <div class="row mb-2">
          <div class="col-12">
            <label>Arquivo</label>
            <br />
            <input
              #thisInput
              type="file"
              name="file"
              data-cy="uploadFile"
              (change)="openFile($event)"
            />
          </div>
        </div>
      </div>
      <div class="col-2" *ngIf="viewStockButton()">
        <input
          type="button"
          value="Visualizar Estoque"
          class="btn btn-primary me-2"
          style="margin-top: 22px; width: 100%"
          appDebounceClick
          (debounceClick)="openStockFundsDialog()"
          [debounceTime]="200"
          [disabled]="portfolio.sourceId == null"
        />
      </div>
      <div class="col-2 mt-2" *ngIf="isWallet">
        <input
          type="button"
          value="{{ isWalletUpload ? 'Carregar' : 'Buscar' }}"
          class="btn btn-primary me-2"
          style="margin-top: 22px; width: 100%"
          appDebounceClick
          (debounceClick)="getAllStock(portfolio.sourceId)"
          [debounceTime]="200"
          [disabled]="portfolio.sourceId == null"
        />
      </div>
    </div>

    <div
      class="row mb-2"
      *ngIf="
        (isB3() ||
          isCetip() ||
          isSelic() ||
          isNoFinancial() ||
          (!isTEDOrMoney() &&
            !isTransferTicket &&
            !isWallet &&
            this.ticketType != ticketTypes().Expenses &&
            this.ticketType != ticketTypes().StructuredOperations)) &&
        !isSovereign()
      "
    >
      <div class="col-6" [class.has-error]="hasError('clearingAccount')">
        <label *ngIf="isB3()">Conta B3</label>
        <label
          *ngIf="
            isCetip() ||
            isNoFinancial() ||
            (!isTEDOrMoney() &&
              !isTransferTicket &&
              !isSelic() &&
              !isB3() &&
              this.ticketType != ticketTypes().Expenses)
          "
          >Conta Cetip</label
        >
        <label *ngIf="isSelic()">Conta Selic</label>
        <input
          [(ngModel)]="portfolio.clearingAccount"
          data-cy="clearingAccount"
          type="text"
          class="form-control"
          name="clearingAccount"
          pattern="\w+-?\w*"
          maxlength="15"
          required
          [readonly]="true"
        />
      </div>
    </div>
  </div>
</form>
